<template>
    <section class="blog-details pt-80px pb-80px">
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="blog-details-content">

                        <div class="blog-user-meta-and-share d-flex justify-content-between">
                            <div class="blog-user-meta d-flex align-center">
                                <img :src="userImg" alt="">
                                <div class="blog-user-meta-right">
                                    <span class="author-name d-inline-flex gap-1">
                                        by <a href="#" class="d-block transition-2s">John Doe</a>
                                    </span>
                                    <p class="user-meta-inner d-flex align-center flex-wrap">
                                        <span class="post-date">22 Jan, 22</span> -
                                        <span class="post-comments">
                                            <el-icon><ChatDotSquare /></el-icon> 22
                                        </span> - 
                                        <span class="post-views">
                                            <el-icon><View /></el-icon> 403
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="share-post d-flex align-center justify-content-end">
                                <p class="m-0">Share</p>
                                <div class="share-post-icons position-relative ml-4">
                                    <el-icon class="show-share-icons" @click="showShareIcons=!showShareIcons">
                                        <Close v-if="showShareIcons" />
                                        <Share v-else />
                                    </el-icon>
                                    <ul class="position-absolute overflow-hidden" :class="showShareIcons ? 'active' : ''">
                                        <li><a href="#"><font-awesome-icon :icon="['fab', 'facebook-f']" /></a></li>
                                        <li><a href="#"><font-awesome-icon :icon="['fab', 'twitter']" /></a></li>
                                        <li><a href="#"><font-awesome-icon :icon="['fab', 'instagram']" /></a></li>
                                        <li><a href="#"><font-awesome-icon :icon="['fab', 'linkedin-in']" /></a></li>
                                        <li><a href="#"><font-awesome-icon :icon="['fab', 'pinterest-p']" /></a></li>
                                        <li><a href="#"><font-awesome-icon :icon="['fab', 'google-plus-g']" /></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <h1>Using web3 to call precompile contract</h1>
                        <p>
                            At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus.
                        </p>
                        <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, esse. Nulla doloremque doloribus dolorum ipsum inventore laudantium voluptas reprehenderit neque facilis ducimus, nam aliquam velit ullam similique, et amet tempora!
                        </p>
                        <h3>Examples</h3>
                        <div class="row mb-30px">
                            <div class="col-md-6">
                                <img class="radius-4" :src="require('@/assets/images/blog4.jpeg')" alt="">
                            </div>
                            <div class="col-md-6">
                                <img class="radius-4" :src="require('@/assets/images/blog5.jpeg')" alt="">
                            </div>
                        </div>
                        <p>
                            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Culpa, error! Consequatur iste quae deserunt quia a sapiente architecto, ad, qui voluptatibus rerum optio rem adipisci? Necessitatibus, recusandae ad? Illo dolor fuga quisquam repudiandae minus officiis itaque magni nemo. Voluptate autem est provident veniam temporibus! Dolor!
                        </p>
                        <blockquote>
                            <p>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Id harum praesentium ullam ea ducimus sunt sit provident maxime officiis temporibus in doloribus, neque corporis illo corrupti minima fugiat unde quidem. Ipsa obcaecati ab quaerat adipisci.
                            </p>
                            <footer class="blockquote-footer">
                                John Doe in <cite title="Source Title">Source Title</cite>
                            </footer>
                        </blockquote>
                        <p>
                            Voluptates voluptate tempora saepe autem architecto temporibus, totam, ab tempore sed fugiat voluptatibus dolore deleniti et eum eveniet minus voluptatem dolores distinctio vitae porro ducimus. Dolorem voluptatem culpa, facere voluptatum necessitatibus officiis praesentium, dolor neque omnis ipsum similique modi nisi, temporibus quam! Necessitatibus, recusandae ad? Illo dolor fuga quisquam repudiandae minus officiis itaque magni nemo. Voluptate autem est provident veniam temporibus! Dolor!
                        </p>
                        <h3>These 5 simple business tricks will pump up your sales instantly</h3>
                        <p>
                            Aut facilis sint cum et sint suscipit vel praesentium. Ut similique laborum necessitatibus et corrupti sed et officia. Qui qui excepturi quaerat vel. Vero eaque et. Illum facere consequatur facere aut dignissimos voluptatem sit ut et. Itaque atque debitis incidunt quaerat totam est excepturi architecto voluptatem. Est et eaque necessitatibus corrupti et et qui eum. Eum totam sint. Dolorem quibusdam blanditiis unde non voluptatibus beatae ut aliquid officiis.
                        </p>

                        <div class="blog-tags d-flex align-center w-full mb-40px">
                            <p class="m-0">Tags:</p>
                            <ul class="blog-sidebar-tags ml-2">
                                <li><router-link to="/">Business</router-link></li>
                                <li><router-link to="/">Start-up</router-link></li>
                                <li><router-link to="/">SEO</router-link></li>
                                <li><router-link to="/">Corporate</router-link></li>
                                <li><router-link to="/">Consulting</router-link></li>
                            </ul>
                        </div>

                        <div class="author-box mb-40px d-flex align-center">
                            <div class="author-img">
                                <img class="w-full" :src="require('@/assets/images/team-4.png')" alt="">
                            </div>
                            <div class="author-box-content pl-30px">
                                <h1>Hi, I'm Mr. Potato 👋</h1>
                                <span class="designation">CEO &amp; Founder</span>
                                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ratione corrupti quibusdam sit veritatis temporibus repudiandae dolor quisquam, enim, nemo sequi nihil tempora saepe eum blanditiis?</p>
                            </div>
                        </div>

                        <comments />


                        <comment-form />
                    </div>

                </div>
                <div class="col-md-4">
                    <blog-sidebar />

                </div>
            </div>
        </div>
    </section>    
</template>

<script>
import { ChatDotSquare, View, Share, Close } from '@element-plus/icons-vue';
import BlogSidebar from '../../sidebars/BlogSidebar.vue'
import Comments from '../../cards/Comments.vue';
import CommentForm from '../../cards/CommentForm.vue';

export default {
    name: 'BlogDetailsContent',
    components: {
        BlogSidebar,
        ChatDotSquare,
        View,
        Share,
        Close,
        Comments,
        CommentForm,
    },
    data() {
        return {
            userImg: require('@/assets/images/team-4.png'),
            showShareIcons: false
        }
    }
}
</script>
